import type { UiStatus } from '../state/conversationStore';

interface Props {
  status: UiStatus;
  ready: boolean;
  recording: boolean;
  inferring: boolean;
  onStart: () => void;
  onStop: () => void;
}

export function RecordingButton({ status, ready, recording, inferring, onStart, onStop }: Props) {
  const label = recording ? '🎙 停止' : '🎙 マイクを開始';
  const color = status === 'speaking' ? '#ff6666' : status === 'inferring' ? '#ffbb33' : '#44aa66';
  // Disable during active inference so a user can't stop the VAD mid-stream
  // and leave a dangling assistant turn. `ready` is informational only:
  // clicking before ready is how init() runs in the first place.
  void ready;
  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
      <button
        onClick={recording ? onStop : onStart}
        disabled={inferring}
        style={{
          padding: '10px 16px',
          borderRadius: 8,
          border: '1px solid #aaa',
          background: recording ? '#eee' : '#fff',
          cursor: inferring ? 'not-allowed' : 'pointer',
          fontSize: 16,
          opacity: inferring ? 0.6 : 1,
        }}
      >
        {label}
      </button>
      <span
        aria-label={`status: ${status}`}
        style={{
          display: 'inline-block',
          padding: '4px 10px',
          borderRadius: 12,
          background: color,
          color: 'white',
          fontSize: 12,
        }}
      >
        {status}
      </span>
    </div>
  );
}
